import { Component } from '@angular/core';
import { VisualAppearance, VisualColor } from '@atpco/hub-ui';
import { Store } from '@ngrx/store';
import * as HelpActions from '@hub-store/help/help.actions';
import * as HelpSelectors from '@hub-store/help/help.selectors';
import { Observable } from 'rxjs';

/**
 * Floating help button, rendered once by the app shell so it is available on
 * every page. Replaces the '?' icon that rh-ui-global-header used to provide.
 *
 * Pressing it swaps the button for the Resource Center panel; the chevron in
 * the panel header swaps back. 'Explore page guide' opens whichever help
 * slideover the current page rendered and is only offered when that page
 * registered content for it.
 */
@Component({
  selector: 'rh-help-button',
  templateUrl: './help-button.component.html',
  styleUrl: './help-button.component.scss'
})
export class RhHelpButtonComponent {
  isPanelOpen = false;

  hasPageGuide$: Observable<boolean> = this.store.select(HelpSelectors.getHasPageGuide);

  visualAppearance = VisualAppearance;
  visualColor = VisualColor;
  chevronButton = [{
    iconAriaLabelInput: 'Collapse Resource Center',
    src: 'chevron-down',
    isIconClickable: true,
    isIconRef: true,
    id: 'chevron-down'
  }];

  trainingLibraryUrl = 'https://atpcolearning.adobeconnect.com/rh/default/index.html';
  serviceNowUrl = 'https://atpco.service-now.com/sp?id=sc_cat_item&sys_id=790006b81ba40a50760275d4cc4bcbd1&sysparm_category=6bf07288db7590d091d1c19115961965';

  constructor(
    private store: Store,
  ) { }

  openPanel() {
    this.isPanelOpen = true;
  }

  closePanel() {
    this.isPanelOpen = false;
  }

  openPageGuide() {
    this.store.dispatch(HelpActions.setHelpVisible({ helpVisible: true }));
    this.closePanel();
  }

  openLink(url: string) {
    window.open(url, '_blank', 'noopener');
  }
}
